export default "__VITE_ASSET__469e4741__"